import { FC, useEffect, useMemo, useState } from "react"
import classNames from "classnames"
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import TextInput from "@/components/shared/TextInput"
import { ColorVariant, Variant } from "@/types/index"
import { capitalizeFirstLetter } from "@/utils/index"

interface FormProps {
   loading: boolean
   kind: string
   isSuccess: boolean
   text?: string
   instruction?: string
   onSave: () => void
}

const Form: FC<FormProps> = ({
   loading,
   kind,
   isSuccess,
   text,
   instruction,
   onSave,
}) => {
   const [confirmationText, setConfirmationText] = useState<string>("")

   useEffect(() => {
      return setConfirmationText("")
   }, [])

   const formHeader = useMemo(() => {
      if (isSuccess) return `${capitalizeFirstLetter(kind)} deleted`

      return instruction ?? `Type in ‘delete’ and confirm to delete the ${kind}`
   }, [isSuccess, kind, instruction])

   return (
      <div
         className={classNames("delete-confirmation-modal__form", {
            "delete-confirmation-modal__form--success": isSuccess,
         })}
      >
         <span className="delete-confirmation-modal__form-header">
            {formHeader}
         </span>
         {isSuccess ? (
            <div className="delete-confirmation-modal__text">{text}</div>
         ) : (
            <TextInput
               variant={Variant.LARGE}
               name="deleteConfirmation"
               onChange={(e) => setConfirmationText(e.target.value)}
               value={confirmationText}
            />
         )}
         <Button
            {...(!isSuccess && { color: ColorVariant.CERISE })}
            {...(!isSuccess && {
               disabled: loading || confirmationText !== "delete",
            })}
            iconName={isSuccess ? "checkmark" : "trashBin"}
            iconPosition={ButtonIconPosition.LEFT}
            onClick={() => onSave()}
         >
            {isSuccess ? "Ok" : `Delete ${kind}`}
         </Button>
      </div>
   )
}

export default Form
